/* eslint-disable indent */
import { AxiosRequestConfig } from 'axios'

import { pixieWorldApiClient, CustomPixieWorldApiServiceOptions } from '@/shared/api/PixieWorldApiService'

export const customInstance = <T>(config: AxiosRequestConfig, options?: CustomPixieWorldApiServiceOptions): Promise<T> => {
  if (config.method?.toLowerCase() === 'put' && config?.url && config.headers?.['Content-Type']?.includes('multipart/form-data')) {
    return pixieWorldApiClient.upload<T>(
      config.url,
      config.data as FormData,
      undefined,
      true,
    )
  }

  return pixieWorldApiClient.request<T>(config, options)
}